import type { RouteRecordRaw } from 'vue-router';

// B2.1 registration page. Magic-link sign-in (B7.1 / B7.1a) is fe-006's
// scope and lands on /:slug/sign-in*; this feature only owns /register.
export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/register',
    name: 'register',
    component: () => import('./pages/RegisterPage.vue'),
    meta: { hideBottomNav: true },
  },
];
